import type { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';

import styles from './DialogContent.module.scss';

export const DialogContent: FC<PropsWithChildren<{ className?: string }>> = ({ className, children }) => (
  <div className={classNames(styles.content, className)}>{children}</div>
);
